import { defineMessage } from 'magpie-lib/models';

const publicApiAvailable = defineMessage({
  type: 'public-api-available' as const,
});

const isPublicApiAvailable = defineMessage({
  type: 'is-public-api-available' as const,
  reply: publicApiAvailable,
});

export const publicApiAvailability = {
  publicApiAvailable,
  isPublicApiAvailable,
};
